import React from "react";
import Navbar1Combine from "./Header/Navbar1Combine";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter as Router } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import Footer from "./Footer/footer";
import banner1 from "./images/sikkimimages/banner.png";
class InnerPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      Tabcontent: "Inclusions",
    };
  }
  render() {
    return (
      <Container fluid className="p-0 m-0">
        <Router>
          <Navbar1Combine />
          <div className="p-0 m-0 aboutuscommonbannerall">
            <img
              src={banner1}
              alt=""
              className="forwebsite"
              style={{ width: "100%" }}
            ></img>
            <img src={banner1} alt="" className="aboutwidth formobile"></img>
          </div>
          <Container className="destinationcard">
            <h1 className="sectionheading">About Us</h1>
            <div className="geeks"></div>
            <h3>What Makes Holxo’s Short Breaks Special</h3>
            <Row>
              <Col lg="12">
                <p
                  style={{
                    textAlign: "justify",
                    fontFamily: "AvenirNext-UltraLight",
                    fontWeight: "700",
                    lineHeight: "30px",
                  }}
                >
                  Adding a new mantra to self-discovery, these breakaway
                  holidays redefine <i>"giving time a break"</i> where you
                  explore off-beat and unique places that will surprize you with
                  things from the ordinary and <i>"intangible"</i> experiences
                  that will be bragworthy over a coffee table conversation.{" "}
                </p>
                <h3>Why Holxo ?</h3>
                <p
                  style={{
                    textAlign: "justify",
                    fontFamily: "AvenirNext-UltraLight",
                    fontWeight: "700",
                    lineHeight: "30px",
                  }}
                >
                  Tried and tested over the years with 100’s of discerning
                  travellers, these special breaks are the culmination of having{" "}
                  <i>“ears on the ground“</i> and a hunger for the special{" "}
                  <i>“zing“</i> – all researched in dept by our travel expert
                  with over 30 years in experiential travel .
                  <br /> We respect that time during for holidays are{" "}
                  <i>“indispensable“</i> , hence to give our customers a
                  wholesome experience , we have designed these short breakaway
                  holidays with meticulous attention to include handpicked
                  special stays , meals with local flavours, out of the way
                  experiences and beautiful environments.
                </p>
              </Col>
            </Row>
          </Container>
          <Footer style={{ margin: "0rem auto auto auto" }} />
        </Router>
      </Container>
    );
  }
}
export default InnerPage;
